import type { CashAndBankRepository } from "../repositories/CashAndBankRepository";
import type { RecentBankTransactionsEntity } from "../entities/RecentBankTransactionsEntity";
import type { GetRecentBankTransactionsParams } from "../repositories/CashAndBankRepository";

export class GetRecentBankTransactionsUseCase {
  constructor(private readonly repository: CashAndBankRepository) {}

  async execute(
    params: GetRecentBankTransactionsParams
  ): Promise<RecentBankTransactionsEntity> {
    return this.repository.getRecentBankTransactions(params);
  }
}
